import { Container, Flex, Box, Text, Link, Image, Button } from "@chakra-ui/react"

export default function Footer() {
    return (
        <Container as="footer" maxW="1170px" w="90%" pt="40px" pb="60px" fontSize="14px" zIndex={10}>
            <Flex
                maxW={{ xl: 1200 }}
                w="100%"
                mx="auto"
                px={{ base: "20px", lg: 0 }}
                justify="space-between"
                align="flex-start"
                direction={{ base: "column", lg: "row" }}
                gap={{ base: "10px", lg: 0 }}
                pb="30px"
                borderBottom="1px solid"
                borderColor="#727376"
            >
                <Box w={{ base: "100%", lg: "33.33%" }} textAlign={{ base: "center", lg: "left" }}>
                    <Text mb={3} color="#727376">
                        Hosted by:
                    </Text>
                    <Image
                        src="https://tctpluslatam.com/wp-content/uploads/2025/10/logos-sbhci-vetor.png"
                        alt="SBHCI Logo"
                        maxH="75px"
                        m={{ base: "0 auto", lg: "0px!important" }}
                    />
                </Box>

                <Box w={{ base: "100%", lg: "33.33%" }} textAlign="center" color="#003B7F">
                    <Text fontSize="15px" fontWeight="500">
                        Rua Beira Rio 45 cj 71 e 74 – Vila Olímpia
                        <br />
                        CEP 04548-050
                        <br />
                        São Paulo – Brasil
                    </Text>
                </Box>

                <Box w={{ base: "100%", lg: "33.33%" }} textAlign="center">
                    <Text color="#003B7F" fontWeight="500" mb={11}>
                        © Copyright 2026. All Rights Reserved
                    </Text>
                    <Link href="https://tctpluslatam.com/contact-us/">
                        <Button
                            bg="#003B7F"
                            color="white"
                            borderRadius="full"
                            px={6}
                            py={3}
                            fontSize="16px"
                            fontWeight="400"
                            _hover={{ bg: "#003B7F" }}
                        >
                            Contacts
                        </Button>
                    </Link>
                </Box>
            </Flex>

            <Box maxW={{ xl: 1200 }} w="100%" mx="auto" px={{ base: "20px", lg: 0 }} pt="10px" textAlign="center">
                <Text color="#727376" fontSize="14px">
                    Copyright 2026 © SBHCI TCT PLUS LATAM VALVES. All Rights Reserved
                </Text>
            </Box>
        </Container>
    )
}
